import type {
  CampaignSection,
  CampaignSectionColumn,
  EmailElement,
} from 'types/content-editor'
import { updateItem } from '@disco/utils/immutable'
export const updateBlock = (
  targetColumn: CampaignSectionColumn,
  contentIndex: number,
  updatedBlock: EmailElement,
): CampaignSectionColumn => {
  let columnContent = [updatedBlock]

  if (targetColumn.columnContent) {
    const content = targetColumn.columnContent
    columnContent = updateItem(content, contentIndex, updatedBlock)
  }

  return { ...targetColumn, columnContent }
}
export const updateColumn = (
  targetSection: CampaignSection,
  columnIndex: number,
  updatedColumn: CampaignSectionColumn,
): CampaignSection => {
  return {
    ...targetSection,
    columns: updateItem(targetSection.columns, columnIndex, updatedColumn),
  }
}
export const traverseSections = (
  sections: CampaignSection[],
  func: (...args: Array<any>) => any,
): CampaignSection[] =>
  sections.map(section => {
    return {
      ...section,
      columns: section.columns.map(column => {
        if (!column.columnContent) return column
        return {
          ...column,
          columnContent: column.columnContent.map(element =>
            func(element, section),
          ),
        }
      }),
    }
  })
